export const UPDATE_MODEL_ACCURACY_STATE = 'UPDATE_MODEL_ACCURACY_STATE'


// WEBPACK FOOTER //
// ./src/data/redux/model_accuracy_details/actiontypes.js